'use strict';

require('./range.directive');
